import { datadogRum } from '@datadog/browser-rum';
import { pascalToSnake } from 'utils/formatters';
import { PropsWithClass } from 'types/sharedComponents';
import { getIconByKey, isChimeComIconToken } from 'utils/iconRegistry';

interface ChimeKitIconProps extends PropsWithClass {
  iconName: string;
  width?: number;
  height?: number;
  testId?: string;
}
const ChimeKitIcon = ({ iconName, testId, ...rest }: ChimeKitIconProps) => {
  const realIconName = pascalToSnake(iconName);

  const testFixture = testId ?? 'chimekit-icon';

  if (!isChimeComIconToken(realIconName)) {
    datadogRum.addError(`LinkedIcon Error: ${realIconName} is not a valid Icon.`);
    return null;
  }

  const Icon = getIconByKey(realIconName);

  return <Icon data-testid={testFixture} {...rest} />;
};

export default ChimeKitIcon;
